<script>
// Chevron e ícone do modo: 14px casa com o rótulo de 13px de `.ia-sidebar-row`.
const TAMANHO_ICONE = 14
const ICONE_ABERTO = 'mdi-chevron-down'
const ICONE_FECHADO = 'mdi-chevron-right'
const COR_ICONE = 'var(--neutral-700)'

// Seção colapsável da sidebar: cabeçalho (chevron + ícone + nome + contador) e
// corpo com borda-guia à esquerda. Controlado — quem abre e fecha é o pai, que
// é quem sabe quantas seções podem ficar abertas ao mesmo tempo.
export default {
  name: 'IntelligenceV2ChatSidebarGroup',
  props: {
    titulo: {
      type: String,
      required: true,
    },
    iconName: {
      type: String,
      default: '',
    },
    // `null` esconde o contador. Zero NÃO esconde: "0" é informação (a pasta
    // existe e está vazia), ausência não é.
    contador: {
      type: Number,
      default: null,
    },
    aberto: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chevron() {
      return this.aberto ? ICONE_ABERTO : ICONE_FECHADO
    },
    ariaExpanded() {
      return this.aberto ? 'true' : 'false'
    },
    mostraContador() {
      return this.contador !== null
    },
    temIcone() {
      return Boolean(this.iconName)
    },
    tamanhoIcone() {
      return TAMANHO_ICONE
    },
    corIcone() {
      return COR_ICONE
    },
  },
  methods: {
    alternar() {
      this.$emit('toggle')
    },
  },
}
</script>

<template>
  <div class="chat-sidebar-group">
    <button
      type="button"
      class="ia-sidebar-row chat-sidebar-group__cabecalho"
      :aria-expanded="ariaExpanded"
      @click="alternar"
    >
      <icon-svg
        :name="chevron"
        :size="tamanhoIcone"
        :color="corIcone"
        class="flex-shrink-0"
      />
      <icon-svg
        v-if="temIcone"
        :name="iconName"
        :size="tamanhoIcone"
        :color="corIcone"
        class="flex-shrink-0"
      />
      <span class="chat-sidebar-group__titulo ia-texto-selo text-truncate">{{ titulo }}</span>
      <span v-if="mostraContador" class="ia-sidebar-aux flex-shrink-0">
        {{ contador }}
      </span>
    </button>

    <div v-if="aberto" class="chat-sidebar-group__corpo">
      <slot />
    </div>
  </div>
</template>

<style lang="sass" scoped>
// A anatomia do cabeçalho (padding, raio, hover, cores) vem de
// `.ia-sidebar-row` (design/_ia-sidebar.sass).
// Rótulo de seção é ETIQUETA, não título: no protótipo "Agentes" e "Recentes"
// são texto pequeno e claro, que organiza a coluna sem competir com os itens.
// Estava em 13px/600 escuro e puxava mais atenção que as próprias conversas.
.chat-sidebar-group__titulo
  color: var(--neutral-700)
  flex: 1
  min-width: 0

// Borda-guia: liga visualmente o corpo ao cabeçalho que o abriu, que é o que
// impede as seções de virarem uma lista contínua indistinguível quando duas
// estão abertas ao mesmo tempo. Alinhada ao centro do chevron (8px de padding
// + 7px de meio ícone).
.chat-sidebar-group__corpo
  margin: 2px 0 4px 15px
  padding-left: 8px
  border-left: 1px solid var(--sidebar-warm-border)
</style>
